const moment = require('moment');

const join = (rules) => (value, data) => rules.map(rule => rule(value, data)).filter(error => !!error)[0 /* first error */];

export const isEmpty = value => value === undefined || value === null || value === '';

export function isNotBeforeToday(value) {
    if (value && moment(value).isBefore(moment(), 'day')) {
        return `Date cannot be in the past`;
    }
}

export function isNotAfterToday(value) {
    if (value && moment(value).isAfter(moment(), 'day')) {
        return `Date cannot be in the future`;
    }
}

export function isNotUnderAge(value) {
    if (value && moment(value).isAfter(moment().subtract(16, 'years'), 'day')) {
        return `You must be 16 or older`;
    }
}

export function email(value) {
    if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(value)) {
        return 'Invalid email address';
    }
}

export function phone(value) {
    if (value && (value.length < 5 || !/^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3,5}\)?[\s.-]?\d{3,4}[\s.-]?\d{2,4}$/.test(value))) {
        return 'Invalid phone number';
    }
}

export function required(value) {
    if (isEmpty(value)) {
        return 'Required';
    }
}

export function minLength(min) {
    return value => {
        if (!isEmpty(value) && value.length < min) {
            return `Must be at least ${min} characters`;
        }
    };
}

export function maxLength(max) {
    return value => {
        if (!isEmpty(value) && value.length > max) {
            return `Must be no more than ${max} characters`;
        }
    };
}

export function minSize(min) {
    return value => {
        if (!isEmpty(value) && Number(value) < min) {
            return `Can not be less than ${min}`;
        }
    };
}

export function maxSize(max) {
    return value => {
        if (!isEmpty(value) && Number(value) > max) {
            return `Can not be more than ${max}`;
        }
    };
}

export function integer(value) {
    if (value && !Number.isInteger(Number(value))) {
        return 'Must be a number';
    }
}

export function oneOf(enumeration) {
    return value => {
        if (!~enumeration.indexOf(value)) {
            return `Must be one of: ${enumeration.join(', ')}`;
        }
    };
}

export function match(field) {
    return (value, data) => {
        if (data) {
            if (value !== data[field]) {
                return 'Do not match';
            }
        }
    };
}

export function createValidator(rules) {
    return (data = {}) => {
        let errors = {};
        Object.keys(rules).forEach((key) => {
            if (Array.isArray(rules[key])) {
                const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
                const error = rule(data[key], data);
                if (error) {
                    errors[key] = error;
                }
            }
            else if (typeof rules[key] === 'object') {
                 // handle nested objects in form
                errors = {...errors, [key]: createValidator(rules[key])(data[key])}
            }
        });
        return errors;
    };
}
